import { useEffect, useMemo, useState } from "react";
import { getKbArticles } from "@/lib/apiClient";
import { Search, ChevronDown } from "lucide-react";

export function KbSearch() {
  const [articles, setArticles] = useState([]);
  const [q, setQ] = useState("");
  const [openId, setOpenId] = useState(null);
  useEffect(() => { getKbArticles().then(setArticles).catch(() => {}); }, []);
  const shown = useMemo(() => {
    const t = q.trim().toLowerCase();
    const pub = articles.filter((a) => a.status === "published");
    return t ? pub.filter((a) => `${a.title} ${a.category} ${a.tags} ${a.body}`.toLowerCase().includes(t)) : pub;
  }, [articles, q]);

  return (
    <div data-testid="kb-search">
      <div className="relative mb-3">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#8994A3]" />
        <input data-testid="kb-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Zoek in de kennisbank…" className="fe-input pl-9" />
      </div>
      {shown.length === 0 ? <p className="text-sm text-[#5B6675]" data-testid="kb-search-empty">Geen artikelen gevonden.</p> : (
        <div className="space-y-2">
          {shown.map((a) => (
            <div key={a.id} className="rounded-xl border border-[#E2E7EC] bg-white">
              <button data-testid={`kb-item-${a.id}`} onClick={() => setOpenId(openId === a.id ? null : a.id)} className="w-full text-left flex items-center gap-2 px-3 py-2.5">
                <span className="text-sm font-medium text-[#16202B]">{a.title}</span>
                {a.category && <span className="text-[11px] px-2 py-0.5 rounded-full bg-[#E3E9F5] text-[#001C51]">{a.category}</span>}
                <ChevronDown className={`h-4 w-4 ml-auto text-[#5B6675] transition-transform ${openId === a.id ? "rotate-180" : ""}`} />
              </button>
              {openId === a.id && <p className="px-3 pb-3 text-sm text-[#16202B] whitespace-pre-wrap leading-relaxed">{a.body}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
